module.exports = __webpack_public_path__ + "media/images/talent/lp/bg-de8f8ee5b24f7faaefc9c8e0b9ca2c00.png";